module.exports = __webpack_public_path__ + "img/Property Hands.b873aeb5.svg";